import { render, staticRenderFns } from "./SpokenLanguagesTable.vue?vue&type=template&id=0ca7fedc&"
import script from "./SpokenLanguagesTable.vue?vue&type=script&lang=js&"
export * from "./SpokenLanguagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports